<mat-card class="todo-card" appearance="raised">
  <mat-card-header>
    <div class="todo-card-header-row">
      <mat-card-title>Todo lists</mat-card-title>
      <mat-chip>{{ todoLists.length }}</mat-chip>
    </div>
  </mat-card-header>

  <mat-card-content>
    <p class="status-text" *ngIf="!todoLists.length">No lists yet. Create your first list.</p>

    <mat-list *ngIf="todoLists.length">
      <mat-list-item
        *ngFor="let list of todoLists"
        class="home-list-item"
        [class.home-list-item-active]="list.id === activeListId"
        (click)="onSelectList(list.id)"
        (keydown.enter)="onSelectList(list.id)"
        (keydown.space)="onSelectList(list.id); $event.preventDefault()"
        tabindex="0"
      >
        <div class="home-list-item-row">
          <div class="home-list-name">{{ list.name }}</div>
          <div class="home-list-meta">
            <mat-chip *ngIf="list.pendingRequests > 0 && list.currentUserRole === 'owner'">{{ list.pendingRequests }}</mat-chip>
            <mat-icon *ngIf="list.shareToken" class="home-list-shared-icon" aria-label="Shared list">group</mat-icon>
          </div>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
